// Define available languages without statically importing locale files
// This allows dynamic imports to properly code-split the locale modules
export const resources = {
  en: {
    translation: {},
  },
} as const

export type Language = keyof typeof resources
